module.exports = __webpack_public_path__ + "img/login2.8729f2c8.svg";